import { getMobilityClaimsPage } from './constants/sites/mobility-claims';
import { getMobilityCustomerServicePage } from './constants/sites/mobility-cc';
import { getMobilityPersonalDataPage } from './constants/sites/mobility-personal';

const checkBannerId = (banner) =>
    window.vngage.solutionIds && window.vngage.solutionIds.includes(banner.config.id);

const updateMobilityClaimsLink = () => {
    const linkOpen = document.getElementById('claims-link-open');
    const linkClosed = document.getElementById('claims-link-closed');
    if (!linkOpen && !linkClosed) return;

    const target = getMobilityClaimsPage(window.location.href);
    if (target) {
        if (linkOpen) linkOpen.setAttribute('href', target);
        if (linkClosed) linkClosed.setAttribute('href', target);
    }
};

const updateMobilityCustomerServiceLink = () => {
    const link = document.getElementById('service-link');
    if (!link) return;

    const target = getMobilityCustomerServicePage(window.location.href);
    if (target) link.setAttribute('href', target);
};

const updateMobilityPersonalDataLink = () => {
    const link = document.getElementById('personal-data-link');
    if (!link) return;

    const target = getMobilityPersonalDataPage(window.location.href);
    if (target) link.setAttribute('href', target);
};

const customizeMobility = () => {
    window.vngage.subscribe('banner:show', (eventName, banner) => {
        if (!checkBannerId(banner)) return;
        updateMobilityClaimsLink();
        updateMobilityCustomerServiceLink();
        updateMobilityPersonalDataLink();
    });
};

export { customizeMobility };
